import React from "react";
import { Layout, Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import Cookies from "js-cookie";

export default function Navbar() {
   let history = useHistory();
   const { Header } = Layout;

   return (
      <Header className="header">
         <Menu
            mode="horizontal"
            style={{ justifyContent: "flex-end", position: "relative" }}
         >
            <Menu.Item key="1" className="logo" style={{ position: "absolute", left: "-40px", top: "-40px" }}>
               <Link to={"/"}><img src={require("../assets/img/WP-01.webp")} width={150} alt="logo"/></Link>
            </Menu.Item>
            <Menu.Item key={"2"}>
               <Link to={"/"}>Home</Link>
            </Menu.Item>
            <Menu.Item key="3">
               <Link to={"/movies"}>Movies</Link>
            </Menu.Item>
            <Menu.Item key="4">
               <Link to={"/games"}>Games</Link>
            </Menu.Item>
            {Cookies.get("token") === undefined && (
               <>
                  <Menu.Item key="5">
                     <Link to={"/register"}>Register</Link>
                  </Menu.Item>
                  <Menu.Item key="6">
                     <Link to={"/login"}>Login</Link>
                  </Menu.Item>
               </>
            )}
            {Cookies.get("token") !== undefined && (
               <Menu.Item
                  key="7"
                  onClick={() => {
                     Cookies.remove("token");
                     history.push("/login");
                  }}
               >
                  Logout
               </Menu.Item>
            )}
         </Menu>
      </Header>
   );
}
